var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgİconAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.678 8.71186V1.59322C11.678 1.26576 11.4122 1 11.0847 1H3.9661C3.63864 1 3.37288 1.26576 3.37288 1.59322V8.71186H1L7.52542 14.6441L14.0508 8.71186H11.678Z",
    stroke: "#999999",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74579 4.85596C6.23723 4.85596 6.63562 4.45756 6.63562 3.96612C6.63562 3.47468 6.23723 3.07629 5.74579 3.07629C5.25435 3.07629 4.85596 3.47468 4.85596 3.96612C4.85596 4.45756 5.25435 4.85596 5.74579 4.85596Z",
    stroke: "#999999",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30511 8.41528C9.79655 8.41528 10.1949 8.01689 10.1949 7.52545C10.1949 7.03401 9.79655 6.63562 9.30511 6.63562C8.81367 6.63562 8.41528 7.03401 8.41528 7.52545C8.41528 8.01689 8.81367 8.41528 9.30511 8.41528Z",
    stroke: "#999999",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89827 2.77966L5.74573 8.11865",
    stroke: "#999999",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgİconAction);
export default __webpack_public_path__ + "static/media/icon_action.3d076ef5c2d2d4339e84bff49e5ed794.svg";
export { ForwardRef as ReactComponent };